const {addFilter}         = wp.hooks;
const {InspectorControls} = wp.editor;
import classnames from 'classnames';


const {
          PanelBody, PanelRow,
          TextControl, SelectControl, RangeControl, ToggleControl,
          ButtonGroup, Button, Icon
      } = wp.components;

const {__}                         = wp.i18n;
const {Fragment}                   = wp.element;
const {createHigherOrderComponent} = wp.compose;

function register_layover_button_filter(settings, name) {

    if (name === "core/button") {

        settings.attributes.layover_mode = {
            type:    'boolean',
            default: false,
        };

        settings.attributes.layover_url = {
            type:    'string',
            default: "",
        };

    }

    return settings;

}


addFilter(
    'blocks.registerBlockType',
    'aws-core-filters/button-block/layover-button',
    register_layover_button_filter,
);


const renderLayoverButtonFilter = createHigherOrderComponent((BlockEdit, otro) => {

    return (props) => {

        if( typeof(props) === "undefined" || typeof(props.name) === "undefined" || props.name !== "core/button" ){
            return <BlockEdit {...props} />;
        }

        const {
                  attributes,
                  setAttributes,
                  isSelected,
              } = props;


        const edit_simple = (value, key) => {

            props.setAttributes({[key]: value});
            props.setAttributes({updated: Date.now()});

        };

        const render_flag = props.name === "core/button";
        const extra_flag  = isSelected && render_flag;

        return (
            <Fragment>
                <BlockEdit {...props} />
                { extra_flag &&
                    <InspectorControls key="inspector">

                        <PanelBody key="panel_body_carousel" title={__('Layover settings')}
                                   className={"aws-full-post-list aws-rm-hidden"}>

                            <PanelRow
                                className={"aws-post-list-sidebar"}
                            >

                                <ToggleControl
                                    label={__("Activate Layover Mode")}
                                    help={__("It will show the content of the link into a layover.")}
                                    checked={props.attributes.layover_mode}
                                    onChange={(value) => edit_simple(value, "layover_mode")}
                                />

                            </PanelRow>

                            <PanelRow
                                className={"aws-post-list-sidebar"}
                            >

                                <TextControl
                                    label={__("URL")}
                                    value={props.attributes.layover_url}
                                    onChange={(value) => edit_simple(value, "layover_url")}
                                />

                            </PanelRow>

                        </PanelBody>
                    </InspectorControls>
                }
            </Fragment>
        );

    };

}, 'renderLayoverButtonFilter');


addFilter(
    'editor.BlockEdit',
    'aws-core-filters/renderLayoverButtonFilter',
    renderLayoverButtonFilter
);